<template>
  <!-- <async-component v-if="$store.state.isShowPage"> -->
    <router-view></router-view>
  <!-- </async-component> -->
  <axiosLoading/>
</template>

<script>
// import { getUserInfo, getMemberfo, getJssdkConfig } from '@/api/apis';
import axiosLoading from '@/components/Loading.vue';
// import wx from 'weixin-js-sdk';
export default {
  components: {
    axiosLoading
  },
  data () {
    return {
    };
  },
  created () {
    if (!this.$cookies.get('sessionId')) {
      this.$router.push('/login');
    }
    // 禁止默认点击事件
    document.oncontextmenu = function (e) {
      // e.preventDefault();
    };
  },
  methods: {
    // getThemetype (item) {
    //   if (item === '深色') {
    //     document.getElementById('app').style.setProperty('--themeColor', '#141519');
    //     document.getElementById('app').style.setProperty('--backColor', '#141519');
    //     document.getElementById('app').style.setProperty('--msgColor', '#1F2024');
    //     document.getElementById('app').style.setProperty('--textColor', '#FFFFFF');
    //     document.getElementById('app').style.setProperty('--text_Color', '#fff');
    //     document.getElementById('app').style.setProperty('--topColor', '#141519');
    //     document.getElementById('app').style.setProperty('--vipColor', '#FFDDB2');
    //     document.getElementById('app').style.setProperty('--popupbottomColor', '#727378');
    //   } else {
    //     document.getElementById('app').style.setProperty('--themeColor', 'rgb(237,237,237)');
    //     document.getElementById('app').style.setProperty('--backColor', '#ffffff');
    //     document.getElementById('app').style.setProperty('--msgColor', '#fff');
    //     document.getElementById('app').style.setProperty('--textColor', '#1F2330');
    //     document.getElementById('app').style.setProperty('--text_Color', '#1F2024');
    //     document.getElementById('app').style.setProperty('--topColor', 'rgb(237,237,237)');
    //     document.getElementById('app').style.setProperty('--vipColor', '#e0ae6c');
    //     document.getElementById('app').style.setProperty('--popupbottomColor', '#c8c8ca');
    //   }
    // }
  }
};
</script>
<style lang="less">
body{
  -webkit-touch-callout:none;/*系统默认菜单被禁用*/
  -webkit-user-select:none;/*webkit浏览器*/
  -khtml-user-select:none;/*早起浏览器*/
  -moz-user-select:none;/*火狐浏览器*/
  -ms-user-select:none;/*IE浏览器*/
  user-select:none;/*用户是否能够选中文本*/
}
*{
  margin: 0;
  padding: 0;
}
#app {
  --themeColor:rgb(237,237,237);
  --backColor:rgb(0,113,254);
  // --backColor:#409EFF;
  // --themeColor:#141519;
  // --backColor:#141519;
  // --msgColor:#1F2024;
  // --textColor:#FFFFFF;
  // --text_Color:#fff;
  // --topColor:#141519;
  // --vipColor:#FFDDB2;
  // --popupbottomColor:#727378;
  height: 100vh; /* 100vh 表示 100% 的视口高度 */
  overflow-y: auto; /* 添加滚动条 */
  background-color: var(--themeColor);
  font-family: PingFangSC-Regular, PingFang SC;
}
img{
  pointer-events:none;
}
</style>
